// Shorts inline play — clicking a Short card swaps the thumbnail for the
// real player IN PLACE (no modal / popup). The embed HTML is pre-rendered
// by PHP into `window.HAEGOZIYA_SHORTS[id]` (see template-parts/home/shorts.php),
// so playback starts without a network round-trip.
//
// Markup contract (template-parts/home/shorts.php):
//   .short-card > .short-card__media[data-short-open][data-short-id]
//   (the media holds the thumbnail + play badge; we replace its contents
//    with the embed and add `.is-playing` to the card)

function play(trigger) {
    const card = trigger.closest('.short-card');
    if (!card || card.classList.contains('is-playing')) return;

    const id    = trigger.getAttribute('data-short-id');
    const html  = (window.HAEGOZIYA_SHORTS || {})[id];
    const media = card.querySelector('.short-card__media');
    if (!html || !media) return;

    media.innerHTML = html;
    card.classList.add('is-playing');

    // Self-hosted <video> → start playback right away. Embedded iframes
    // (Instagram / TikTok) render their own inline player UI.
    const video = media.querySelector('video');
    if (video) {
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
    }
}

// Request fullscreen on a card's media (mounts the player first if needed).
function goFullscreen(card) {
    if (!card) return;
    const media = card.querySelector('.short-card__media');
    if (!media) return;
    if (!card.classList.contains('is-playing')) {
        play(media);
    }
    const el = media.querySelector('video') || media.querySelector('iframe') || media;
    const req = el.requestFullscreen || el.webkitRequestFullscreen || el.webkitEnterFullscreen || el.msRequestFullscreen;
    if (req) { try { req.call(el); } catch (_) {} }
}

document.addEventListener('click', e => {
    // Full-screen expand button takes priority over play.
    const fs = e.target.closest('[data-short-fullscreen]');
    if (fs) {
        e.preventDefault();
        e.stopPropagation();
        goFullscreen(fs.closest('.short-card'));
        return;
    }

    const trigger = e.target.closest('[data-short-open]');
    if (!trigger) return;
    // Once the player is mounted, let clicks fall through to its own controls.
    if (trigger.closest('.short-card.is-playing')) return;
    e.preventDefault();
    play(trigger);
});

// Keyboard: the media acts as a button (role=button, tabindex=0).
document.addEventListener('keydown', e => {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    const trigger = e.target.closest('[data-short-open]');
    if (!trigger || trigger.closest('.short-card.is-playing')) return;
    e.preventDefault();
    play(trigger);
});
